import { Autocomplete, TextField, autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { type Control, Controller } from "react-hook-form";
import type { TModalSocialOfferFormResolver } from "../logics/resolver";

interface IModalSocialOfferFormFieldFinancingModesProps {
  control: Control<TModalSocialOfferFormResolver>;
}

export const ModalSocialOfferFormFieldFinancingModes = ({ control }: IModalSocialOfferFormFieldFinancingModesProps) => {
  const { settingsV2 } = useGlobalContext();

  return (
    <Controller
      name="financingModes"
      control={control}
      defaultValue={[]}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <Autocomplete
          multiple
          limitTags={1}
          value={value}
          onChange={(_, value) => onChange(value)}
          getOptionLabel={(v) => v.label}
          isOptionEqualToValue={(a, b) => a.value === b.value}
          options={settingsV2.financingModes?.values ?? []}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Type de financement"
              error={Boolean(error)}
              helperText={error?.message}
              inputRef={ref}
            />
          )}
          size="small"
          disableCloseOnSelect
          slotProps={{
            chip: {
              color: "yellow",
              size: "small",
              sx: { [`&.${autocompleteClasses.tag}`]: { mt: 0 } },
            }
          }}
        />
      )}
    />
  );
};
